export default "__VITE_ASSET__a3c94092__"